import { createFileRoute } from '@tanstack/react-router'

import { MessagingProfilesPage } from '#/modules/communication/messaging-profiles-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/messaging-profiles')({
  component: MessagingProfilesPage,
  validateSearch: validateListSearch,
})
